import script from "./NewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCard.vue?vue&type=script&setup=true&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=8a6abef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a6abef0"]])

export default __exports__